import React from 'react';

import LoginForm from './LoginForm';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faSpinner} from '@fortawesome/free-solid-svg-icons';
import Logo from '../../img/logo_white.png';

export default function SplashScreen({appState, appStates, pageStatus, appFns, loginError}) {

    switch(appState) {
        // Login: Show login form
        case appStates.LOGIN:
            return <div className="SplashScreen">
                <img className="SplashScreen-logo" src={Logo} />
                <h3 className="SplashScreen-title">PDU Management</h3>
                <LoginForm loginFunction={appFns.login} loginError={loginError}></LoginForm>
                <span className="SplashScreen-text">
                    <a id="edugateLogin" className="btn btn-danger" href="/ui_auth/authenticate">Log in with Edugate</a>
                </span>
            </div>
        // Loading: show spinner and page status
        case appStates.LOADING:
            return <div className="SplashScreen">
                <img className="SplashScreen-logo" src={Logo} />
                <h3 className="SplashScreen-title">PDU Management</h3>
                <div className="SplashScreen-spinner"><FontAwesomeIcon icon={faSpinner} className="fa-spin"></FontAwesomeIcon></div>
                <span className={`SplashScreen-text`}>{pageStatus}</span>
            </div>
        // Ready: App is ready, don't render splashscreen
        case appStates.READY:
        default:
            return ''
    }
}